import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'productFilterPipe',
})
export class ProductFilterPipe implements PipeTransform {
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => item.Name.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
}
  // transform(items: any, searchTemplate: string, defaultFilter: boolean): any {
  //   if (!searchTemplate){
  //     return items;
  //   }

  //   if (!Array.isArray(items)){
  //     return items;
  //   }

  //   if (searchTemplate && Array.isArray(items)) {
  //     let searchTemplateKeys = Object.keys(searchTemplate);

  //     if (defaultFilter) {
  //       return items.filter(item =>
  //           searchTemplateKeys.reduce((x, keyName) =>
  //               (x && new RegExp(searchTemplate[keyName], 'gi').test(item[keyName])) || searchTemplate[keyName] == "", true));
  //     }
  //     else {
  //       return items.filter(item => {
  //         return searchTemplateKeys.some((keyName) => {
  //           return new RegExp(searchTemplate[keyName], 'gi').test(item[keyName]) || searchTemplate[keyName] == "";
  //         });
  //       });
  //     }
  //   }
  // }
}

    // console.log(additionl);
    // if(searchText === undefined) return value ;
    // return value.searchTemplate(function (searchObj) {
      // return searchObj[additionl].toLowerCase().includes(searchText.toLowerCase());
      // console.log("search", searchObj[additionl].toLowerCase().includes(searchText.toLowerCase()))
    // });
  // }
// }



// WEBPACK FOOTER //
// ./src/pipes/product-filter/productFilter.ts